import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.delivery]: 'Delivery',
  [ORDER_METHODS.pickup]: 'Pickup',
  [ORDER_METHODS.on_site]: 'Table ordering',
};
